import { toastSelector } from "../reducers/ToastReducer";
import { SHOW_TOAST, DISMISS_TOAST, UPDATE_TOAST, toastType } from "./Common";

export class Toast {
  constructor(type, message, duration = 10000, onPositiveAction, onNegativeAction) {
    this.id = Math.random();
    this.type = type;
    this.message = message;
    this.duration = duration;
    this.onPositiveAction = onPositiveAction;
    this.onNegativeAction = onNegativeAction;
    this.dismissOnOutsideClick = true;
    this.actionButtonTitle = null;
    this.dismissOnActionButtonClick = true;
    // Don't show close/dismiss button for generic errors. On desktop and mobile
    this.showDismissButton = type !== toastType.GENERIC_ERROR;
    this.dismissOnNavigationToCategory = null;
  }
}

export const showToastAction = toast => ({
  type: SHOW_TOAST,
  toast
});

export const dismissToastAction = toast => ({
  type: DISMISS_TOAST
});

// Updates the message of the currently shown toast in place (matched by id) without
// dismissing/re-animating it — used for live progress counts.
export const updateToastAction = (id, message) => ({
  type: UPDATE_TOAST,
  id,
  message
});

export const showToastTip = (
  type,
  message,
  didShow = null,
  tipDuration = -1,
  actionButtonTitle = null,
  onPositiveAction = null,
  onNegativeAction = null,
  removeCurrentToast = false,
  dismissOnActionButtonClick = false,
  dismissOnOutsideClick = false
) => {
  return (dispatch, getState) => {
    const currentToast = toastSelector(getState());
    if (currentToast && removeCurrentToast === false) {
      if (didShow) {
        didShow(false);
      }
      return;
    } else if (currentToast && removeCurrentToast === true) {
      dispatch(dismissToastAction());
    }

    const toast = new Toast(toastType[type], message, tipDuration, onPositiveAction, onNegativeAction);
    toast.actionButtonTitle = actionButtonTitle;
    toast.dismissOnActionButtonClick = dismissOnActionButtonClick;
    toast.dismissOnOutsideClick = dismissOnOutsideClick;
    dispatch(showToastAction(toast));
    if (didShow) {
      didShow(true);
    }
  };
};
